<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.vehicle}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="motorForm.vehRegNo" v-uppercase="motorForm.vehRegNo" :label="tariffParam.vehRegMand ? labels.vehRegNoMand:labels.vehRegNo" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" :data-vv-as="labels.vehRegNo" v-validate="tariffParam.vehRegMand ? 'required|veh_reg_no|max:8' : 'veh_reg_no|max:8'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="$mode !== 'ecics'">
              <v-autocomplete :items="quoteParam.vehUsg" v-model="motorForm.vehUsg" :label="labels.vehUsg" item-text="label" item-value="value" data-vv-name="vehUsg" :data-vv-as="labels.vehUsg" :error-messages="errors.collect('vehUsg')" v-validate="'required'" :loading="usgLoading" :hint="getPermitStatusLabel(vehUsgStatus)" :persistent-hint="true" :class="getPermitStatusClass(vehUsgStatus)"></v-autocomplete>
            </v-flex>
            <v-flex v-else lg6 xs12>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap align-content-start>
                <v-flex xs12>
                  <v-autocomplete :items="quoteParam.vehMake.data" v-model="motorForm.vehMake" :label="labels.vehMake" item-text="label" item-value="value" data-vv-name="vehMake" :data-vv-as="labels.vehMake" :error-messages="errors.collect('vehMake')" v-validate="'required'" @input="doMake" :loading="makeLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete :items="quoteParam.vehModel" v-model="motorForm.vehModel" :label="labels.vehModel" item-text="label" item-value="value" data-vv-name="vehModel" :data-vv-as="labels.vehModel" :error-messages="errors.collect('vehModel')" v-validate="'required'" :hint="getPermitStatusLabel(modelParam.permitStatus)" :persistent-hint="true" :class="getPermitStatusClass(modelParam.permitStatus)" @input="doModel" :loading="modelLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <v-card color="grey lighten-4" class="mb-4">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xl5 lg7 xs4 class="modelInfo">
                      <v-icon>mdi-car-sports</v-icon>
                      <span>{{labels.vehBodyType}}</span>
                    </v-flex>
                    <v-flex xl7 lg5 xs8>
                      {{modelParam.bodyType}}
                    </v-flex>
                    <v-flex xl5 lg7 xs4 class="modelInfo">
                      <v-icon>mdi-engine-outline</v-icon>
                      <span>{{labels.vehCapacity}}</span>
                    </v-flex>
                    <v-flex xl7 lg5 xs8>
                      {{modelParam.engineCC}}
                    </v-flex>
                    <template v-if="$mode !== 'ecics'">
                      <v-flex xl5 lg7 xs4 class="modelInfo">
                        <v-icon>mdi-weight</v-icon>
                        <span>{{labels.vehTonnage}}</span>
                      </v-flex>
                      <v-flex xl7 lg5 xs8>
                        {{modelParam.tonnage}}
                      </v-flex>
                    </template>
                    <v-flex xl5 lg7 xs4 class="modelInfo">
                      <v-icon>mdi-seat-recline-normal</v-icon>
                      <span>{{labels.vehNoSeats}}</span>
                    </v-flex>
                    <v-flex xl7 lg5 xs8>
                      {{modelParam.noSeats}}
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 2}" v-model="motorForm.vehRegMth" :label="labels.vehRegMth" :error-messages="errors.collect('vehRegMth')" data-vv-name="vehRegMth" :data-vv-as="labels.vehRegMth" v-validate="'numeric|max_value:12|min_value:1'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 4}" v-model="motorForm.vehRegYr" :label="labels.vehRegYr" :error-messages="errors.collect('vehRegYr')" data-vv-name="vehRegYr" :data-vv-as="labels.vehRegYr" v-validate="'required|numeric|max_value:9999|min_value:1900'" :hint="getPermitStatusLabel(vehRegYrStatus)" :persistent-hint="true" :class="getPermitStatusClass(vehRegYrStatus)"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 4}" v-model="motorForm.vehManuYr" :label="labels.vehManuYr" :error-messages="errors.collect('vehManuYr')" data-vv-name="vehManuYr" :data-vv-as="labels.vehManuYr" v-validate="'numeric|max_value:9999|min_value:1900'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="$mode !== 'ecics'">
              <v-text-field class="mavPrefix" v-num-mask v-model="motorForm.vehValue" :label="tariffParam.vehValMand? labels.vehValueMand:labels.vehValue" type="tel" :error-messages="errors.collect('vehValue')" data-vv-name="vehValue" :data-vv-as="labels.vehValue" v-validate="tariffParam.vehValMand ? 'required|mask_decimal:2|mask_min_value:1|mask_max_value:9999999999.99': 'mask_decimal:2|mask_min_value:0|mask_max_value:9999999999.99'" :prefix="$store.state.agency.quotation.commonInfo.currPrefix"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-else></v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <template v-if="$mode === 'ecics'">
        <v-divider></v-divider>
        <v-card-title>
          <div class="body-2">{{labels.tonnInfo}}</div>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex lg6 xs12>
                <v-text-field ref="maxLaden" v-num-mask v-model="motorForm.maxLaden" :label="labels.maxLaden" type="tel" :error-messages="errors.collect('maxLaden')" data-vv-name="maxLaden" :data-vv-as="labels.maxLaden" v-validate="'mask_decimal:2|mask_min_value:1|mask_max_value:9999999999.99'" suffix="KG" @change="getCalcTonnage" :disabled="!perTonnage"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field ref="unLaden" v-num-mask v-model="motorForm.unLaden" :label="labels.unLaden" type="tel" :error-messages="errors.collect('unLaden')" data-vv-name="unLaden" :data-vv-as="labels.unLaden" v-validate="'mask_decimal:2|mask_min_value:1|mask_max_value:9999999999.99'" suffix="KG" @change="getCalcTonnage" :disabled="!perTonnage"></v-text-field>
              </v-flex>
              <v-flex lg6 xs12>
                <v-text-field prepend-icon="mdi-weight" v-num-mask v-model="motorForm.calcTonnage" :label="labels.calcTonnage" type="tel" :error-messages="errors.collect('calcTonnage')" data-vv-name="unLaden" :data-vv-as="labels.calcTonnage" disabled :loading="tonnageLoading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_PARAM_VEHICLE, QUOTE_MOTOR_PARAM_MAKE, QUOTE_MOTOR_PARAM, QUOTE_MOTOR_VEHICLE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { extractMenu, extractRecord } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'
import { vehRegYrStatus } from './permStatus'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      labels: {
        vehicle: 'Vehicle Information',
        vehRegNo: 'Registration No.',
        vehRegNoMand: 'Registration No.*',
        vehMake: 'Make*',
        vehModel: 'Model*',
        vehBodyType: 'Body Type',
        vehCapacity: 'Capacity',
        vehTonnage: 'Tonnage',
        vehNoSeats: 'No. of Seats',
        vehManuYr: 'Manufacture Year',
        vehRegYr: 'Registration Year*',
        vehRegMth: 'Registration Month',
        vehUsg: 'Usage*',
        vehValue: 'Value',
        vehValueMand: 'Value*',
        maxLaden: 'Maximum Laden Weight',
        unLaden: 'Maximum Unladen Weight',
        calcTonnage: 'Calculated Tonnage',
        tonnInfo: 'Tonnage Information'
      },
      motorForm: {
        vehRegNo: undefined,
        vehMake: undefined,
        vehModel: undefined,
        vehManuYr: undefined,
        vehRegYr: undefined,
        vehRegMth: undefined,
        vehUsg: undefined,
        vehValue: undefined,
        maxLaden: undefined,
        unLaden: undefined,
        calcTonnage: undefined
      },
      modelInfo: {
        vehBodyType: undefined,
        vehCapacity: undefined,
        vehTonnage: undefined,
        vehNoSeats: undefined
      },
      makeLoading: false,
      modelLoading: false,
      usgLoading: false,
      tonnageLoading: false
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    tariffParam() {
      const tariff = this.globalForm.tariff
      const tariffParam = this.quoteParam.tariff.filter(param => param.value === tariff)
      if (tariffParam && tariffParam.length > 0) {
        return tariffParam[0]
      } else {
        return {
          vehRegMand: true,
          vehValMand: true
        }
      }
    },
    modelParam() {
      if (this.quoteParam.vehModel && this.quoteParam.vehModel.length > 0 && this.motorForm.vehModel) {
        const modelParam = this.quoteParam.vehModel.filter(param => param.value === this.motorForm.vehModel)
        if (modelParam && modelParam.length > 0) {
          return modelParam[0]
        } else {
          return {
            bodyType: undefined,
            engineCC: undefined,
            tonnage: undefined,
            noSeats: undefined,
            manuYr: undefined,
            permitStatus: 'A'
          }
        }
      } else {
        return {
          bodyType: undefined,
          engineCC: undefined,
          tonnage: undefined,
          noSeats: undefined,
          manuYr: undefined,
          permitStatus: 'A'
        }
      }
    },
    vehUsgStatus() {
      let result = 'A'
      if (this.motorForm.vehUsg !== null && this.quoteParam.vehUsg) {
        const vehUsg = this.quoteParam.vehUsg.filter(param => param.value === this.motorForm.vehUsg)
        if (vehUsg && vehUsg.length > 0) {
          return vehUsg[0].secondaryValue
        }
      }
      return result
    },
    vehRegYrStatus() {
      if (this.motorForm.vehRegYr !== null && this.globalCommonForm.startDate) {
        const vehAge = toDate(this.globalCommonForm.startDate).getFullYear() - this.motorForm.vehRegYr
        return vehRegYrStatus(vehAge)
      } else {
        return 'A'
      }
    },
    proceedLoading() {
      if (this.makeLoading || this.modelLoading || this.usgLoading || this.tonnageLoading) {
        return true
      } else {
        return false
      }
    },
    perTonnage() {
      const param = extractRecord(this.quoteParam.busCls, this.globalForm.busCls)
      if (param) {
        return param.perTonnage
      }
      return false
    }
  },
  methods: {
    async doInit() {
      // Default value from vuex store 1st
      this.motorForm.vehRegNo = this.globalForm.vehRegNo
      this.motorForm.vehUsg = this.globalForm.vehUsg
      this.motorForm.vehMake = this.globalForm.vehMake
      this.motorForm.vehModel = this.globalForm.vehModel
      this.motorForm.vehManuYr = this.globalForm.vehManuYr
      this.motorForm.vehRegMth = this.globalForm.vehRegMth
      this.motorForm.vehRegYr = this.globalForm.vehRegYr
      this.motorForm.vehValue = this.globalForm.vehValue
      this.motorForm.maxLaden = this.globalForm.maxLaden
      this.motorForm.unLaden = this.globalForm.unLaden
      this.motorForm.calcTonnage = this.globalForm.calcTonnage

      // N2-42 retain values, not displayed in form
      this.motorForm.engineNo = this.globalForm.engineNo
      this.motorForm.chassisNo = this.globalForm.chassisNo
      this.motorForm.finInst = this.globalCommonForm.finInst

      // Default vehUsage (in 2 places - 1 at this.getUsg() calling below, and 1 here)
      // because user can go back page and the value is not saved
      if (!this.motorForm.vehUsg && this.quoteParam.vehUsg && this.quoteParam.vehUsg.length > 0) {
        this.motorForm.vehUsg = this.quoteParam.vehUsg[0].value
      }

      if (!this.perTonnage) {
        this.motorForm.maxLaden = null
        this.motorForm.unLaden = null
        this.motorForm.calcTonnage = null
      }

      if (!this.quoteParam.vehicleLoaded) {
        await this.getUsg()
        if (!this.motorForm.vehUsg && this.quoteParam.vehUsg && this.quoteParam.vehUsg.length > 0) {
          this.motorForm.vehUsg = this.quoteParam.vehUsg[0].value
        }
        await this.getMake()
        if (this.motorForm.vehMake) {
          this.doMake(false)
        }
        this.$store.commit(QUOTE_MOTOR_PARAM_VEHICLE, true)
      }
    },
    async getMake() {
      const apiURI = this.$store.state.agency.quotation.menu.vehMake
      if (apiURI) {
        this.makeLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const menu = extractMenu(data._links)
            Object.assign(data, {
              menu: menu
            })
            this.$store.commit(QUOTE_MOTOR_PARAM_MAKE, data)
            this.makeLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.makeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getUsg() {
      const apiURI = this.$store.state.agency.quotation.menu.vehUsg
      if (apiURI) {
        this.usgLoading = true
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result
            const commitResult = {
              vehUsg: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
            this.usgLoading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.usgLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getCalcTonnage() {
      if (this.motorForm.maxLaden && this.motorForm.unLaden) {
        const apiURI = this.$store.state.agency.quotation.menu.calcTonnage
        if (apiURI) {
          this.tonnageLoading = true
          try {
            // Unmask
            this.$refs.maxLaden.$el.cleave.setRawValue(this.motorForm.maxLaden)
            this.$refs.unLaden.$el.cleave.setRawValue(this.motorForm.unLaden)
            const unMaskMaxLaden = this.$refs.maxLaden.$el.cleave.getRawValue()
            const unMaskUnLaden = this.$refs.unLaden.$el.cleave.getRawValue()
            const expand = {
              maxLaden: unMaskMaxLaden,
              unLaden: unMaskUnLaden
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            if (result.data) {
              const { data } = result.data
              this.motorForm.calcTonnage = data
              this.tonnageLoading = false
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            this.tonnageLoading = false
          }
        } else {
          this.$snotify.error('Invalid API URL')
        }
      } else {
        this.motorForm.calcTonnage = null
      }
    },
    doMake(doReset = true) {
      if (doReset) {
        // reset model values
        this.resetModel()
      }

      this.getModel()
    },
    async getModel() {
      const apiURI = this.quoteParam.vehMake.menu.vehModel
      if (apiURI) {
        this.modelLoading = true
        try {
          const expand = {
            busCls: this.globalForm.busCls,
            vehMake: this.motorForm.vehMake
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              vehModel: data.data
            }
            this.$store.commit(QUOTE_MOTOR_PARAM, commitResult)
            this.modelLoading = false

            // Check if the current model value is still valid
            if (this.motorForm.vehModel && this.quoteParam.vehModel && this.quoteParam.vehModel.length > 0) {
              const validModel = this.quoteParam.vehModel.filter(model => model.value === this.motorForm.vehModel)

              // Invalid tariff (reset to undefined)
              if (!validModel || validModel.length === 0) {
                this.resetModel()
              }
            } else {
              this.resetModel()
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.modelLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doModel() {
      // Veh information will be derieve from computed property
      this.motorForm.vehManuYr = this.modelParam.manuYr
    },
    resetModel() {
      // Reset Model related values
      this.motorForm.vehModel = undefined
      this.modelInfo.vehBodyType = undefined
      this.modelInfo.vehCapacity = undefined
      this.modelInfo.vehTonnage = undefined
      this.modelInfo.vehNoSeats = undefined
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'motorQuoteDriver' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.commit(QUOTE_MOTOR_VEHICLE, this.motorForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
          // Fetch motor plans here instead of at stats screen (from premium back to stats - not loading plans again)
          this.$store.dispatch('motorQuotePlans')
          this.$router.push({ name: 'motorQuoteStatistics' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.commit(QUOTE_MOTOR_VEHICLE, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  props: {
    getPermitStatusLabel: {
      type: Function,
      default: function (status) {
        return ''
      }
    },
    getPermitStatusClass: {
      type: Function,
      default: function (status) {
        return ''
      }
    }
  }
}
</script>

<style lang="scss">
.modelInfo {
  span {
    padding-left: 10px;
  }
}
</style>
